<template>
  <tr
    v-if="task"
    :class="{ deleted: isDeleted }"
    :style="{ 'background-color': highlightColor }"
    :title="label"
    @dblclick="$router.push({ name: 'tasksDetail', query: { backProjectId }, params: { id: taskId } })"
  >
    <td class="asd-btn-group">
      <router-link :to="{ name: 'tasksDetail', query: { backProjectId }, params: { id: taskId } }">
        <button v-help.mouse="`Editovat úkol`"
                type="button"
                class="asd-btn-edit"
        >
          <i class="fas fa-pencil-alt"></i>
        </button>
      </router-link>
    </td>
    <td @click="highlightRow">
      {{ taskType.name }}
    </td>
    <td v-if="showProjectColumn"
        class="project-link"
    >
      <router-link tag="div"
                   :to="{ name: 'projectsDetail', params: { id: project.id } }"
      >
        {{ project.name }}
      </router-link>
    </td>
    <td v-for="(prop, key) in propertiesToShow"
        :key="key"
        :class="{ 'empty-value': !prop }"
        @click="highlightRow"
    >
      <template v-if="prop">
        <PropertyDetailProxy :id="key"
                             :key="key"
                             :value="prop"
        ></PropertyDetailProxy>
      </template>
      <template v-else>
      </template>
    </td>
    <!-- <td class="indicator-td">
      <span v-if="taskComments.length" class="comment-indicator">
        <i class="far fa-comment fa-2x"></i>
        <span class="badge badge-danger count-badge">{{ taskComments.length }}</span>
      </span>
    </td>
    <td class="indicator-td">
      <span v-if="taskAttachments.length" class="attachment-indicator">
        <i class="fas fa-paperclip fa-2x"></i>
        <span class="badge badge-danger count-badge">{{ taskAttachments.length }}</span>
      </span>
    </td> -->
    <div
      class="modal fade bd-example-modal-sm show"
      tabindex="-1"
      role="dialog"
      :style="{ display: showModal ? 'block' : 'none' }"
    >
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <h4 id="mySmallModalLabel"
                class="modal-title"
            >
              Smazat úkol?
            </h4>
          </div>
          <div class="modal-body modal-footer">
            <button type="button"
                    class="btn btn-primary"
                    @click="showModal = false"
            >
              Storno
            </button>
            <button type="button"
                    class="btn btn-danger"
                    @click="disableTask()"
            >
              Smazat
            </button>
          </div>
        </div>
      </div>
    </div>
  </tr>
</template>

<script>
import LangFilters from 'CORE/mixins/langFilters'
import TaskDataMixin from 'CORE/mixins/task-data'
import RowHighlightMixin from 'CORE/mixins/row-highlight'
import PropertyDetailProxy from 'CORE/components/data-type/property-detail-proxy'
import labels from 'CORE/utils/labels'
import _ from 'lodash'

export default {
    name: 'TaskRow',
    components: {
        PropertyDetailProxy,
    },
    mixins: [LangFilters, TaskDataMixin, RowHighlightMixin],
    props: {
        taskId: {
            type: String,
            required: true,
        },
        propsToShow: {
            type: Array,
            required: false,
            default: _ => [],
        },
        showProjectColumn: {
            type: Boolean,
            default: _ => true,
            required: false,
        },
        backProjectId: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data() {
        return {
            showModal: false,
        }
    },
    computed: {
        propertiesToShow() {
            const pts = {}
            for (const p of this.propsToShow) {
                _.set(pts, p, _.get(this, `task.propertyValues.${p}`))
            }
            return pts
        },
        project() {
            const project = this.$store.getters.getProjectById(_.get(this, 'task.project.id'))
            return {
                id: _.get(project, 'id'),
                name: labels.project(project),
                color: null, // currently disabled, TODO finish rainbow module
            }
        },
        isDeleted() {
            return !!_.get(this.task, 'validUntil', false)
        },
        label() {
            return labels.task(this.task)
        },
    },
    methods: {
        openAssignModal() {
            this.$emit('assign', this.taskId)
        },
        async disableTask() {
            try {
                await this.$store.dispatch('disableTask', this.task.id)
                await this.$store.dispatch('tasksLoad')
                this.flash('Ukol byl označen k smazání. Avšak zůstane ještě 7 dní v archivu.', 'success', {
                    timeout: 5000,
                })
            } catch (e) {
                this.flash(`Chyba ${e}`, 'danger')
            } finally {
                this.showModal = false
            }
        },
    },
}
</script>

<style scoped>
.modal {
    background-color: rgba(0, 0, 0, 0.5);
}
.count-badge {
    position: absolute;
    right: 2px;
}
.attachment-indicator > svg,
.comment-indicator > svg {
    color: silver;
}
.project-link {
    color: firebrick;
    font-weight: bold;
    cursor: pointer;
}
</style>
